import { notification } from 'antd';

export const createNotification = (type, message, description) => {
  notification[type]({
    message,
    description,
  });
};
